<template>
    <input type="text" inputmode="numeric" @change="onChange" @keydown="onKeyDown" @click="onClick" @focus="onFocus" :value="internalValue" />
</template>

<script>
    export default {
        props: {
            value: {
                required: false,
            },
            allowZero: {
                type: Boolean,
                required: false,
            },
            valueWhenEmpty: {
                type: Number,
                required: false,
                default: 1,
            },
        },

        data() {
            return {
                internalValue: this.value,
            };
        },

        watch: {
            value(newValue, oldValue) {
                if (newValue <= 0 && !this.allowZero) {
                    throw new Error('Unable to set non-positive integer')
                }
                this.internalValue = newValue;
            }
        },

        methods: {
            onChange(event) {
                event.preventDefault();

                const qty = parseInt(event.target.value);
                if (qty >= 0) {
                    this.internalValue = qty;
                    this.$emit('input', qty);
                } else {
                    this.internalValue = this.valueWhenEmpty;
                    this.$emit('input', this.valueWhenEmpty);
                }

                this.$el.value = this.internalValue + "";
            },

            onKeyDown(event) {
                const authorizedKeys = [
                    'Backspace',
                    'Delete',
                    'Enter',
                    'ArrowLeft',
                    'ArrowRight',
                    'Home',
                    'End',
                    'Tab',
                ];
                if ((event.key < '0' || event.key > '9') && authorizedKeys.indexOf(event.code) < 0) {
                    event.preventDefault();
                    return false;
                }
            },

            onClick(event) {
                event.target.select();
            },

            onFocus(event) {
                event.target.select();
            },
        },
    }
</script>
